import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { GroupContext } from './group-context.js';

var CheckboxManager = function CheckboxManager(_ref) {
  var onChange = _ref.onChange,
      valueFromProps = _ref.value,
      defaultValue = _ref.defaultValue,
      isError = _ref.isError,
      theme = _ref.theme,
      size = _ref.size,
      disabled = _ref.disabled,
      mode = _ref.mode,
      children = _ref.children;
  var isControlled = typeof valueFromProps !== 'undefined';

  var _useState = useState(defaultValue || []),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var prevValue = useRef(value);
  useEffect(function () {
    // in controlled mode the onChange is already called
    if (!isControlled && onChange && prevValue.current !== value) {
      onChange(value);
      prevValue.current = value;
    }
  }, [isControlled, onChange, value]);
  var addToValue = useCallback(function (val) {
    if (!isControlled) {
      setValue(function (prevVal) {
        return _concatInstanceProperty(prevVal).call(prevVal, val);
      });
    } else if (onChange) {
      onChange(_concatInstanceProperty(valueFromProps).call(valueFromProps, val));
    }
  }, [onChange, isControlled, valueFromProps]);
  var removeFromValue = useCallback(function (val) {
    if (!isControlled) {
      setValue(function (prevVal) {
        return _filterInstanceProperty(prevVal).call(prevVal, function (v) {
          return v !== val;
        });
      });
    } else if (onChange) {
      onChange(_filterInstanceProperty(valueFromProps).call(valueFromProps, function (v) {
        return v !== val;
      }));
    }
  }, [onChange, isControlled, valueFromProps]);
  var handleCheckboxChange = useCallback(function (e) {
    if (e.target.checked) {
      addToValue(e.target.value);
    } else {
      removeFromValue(e.target.value);
    }
  }, [addToValue, removeFromValue]);
  return /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: {
      value: isControlled ? valueFromProps : value,
      addToValue: addToValue,
      removeFromValue: removeFromValue,
      handleCheckboxChange: handleCheckboxChange,
      isError: isError,
      theme: theme,
      disabled: disabled,
      size: size,
      mode: mode,
      inGroup: true
    }
  }, children);
};

CheckboxManager.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.array,
  isError: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']),
  size: PropTypes.oneOf(['s', 'm', 'l']),
  mode: PropTypes.oneOf(['classic', 'rock']),
  disabled: PropTypes.bool
};
export { CheckboxManager as default };
